import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AppLocaleTag } from "@/shared/i18n";
import { DEFAULT_LOCALE } from "@/shared/constants";

/**
 * App-level locale state (FR-A8: app Redux owns language/user settings).
 * The tag drives both translated UI strings (`shared/i18n`) and number /
 * currency / datetime formatting (`Intl` in the library configs and
 * `shared/utils/format`).
 */
export interface LocaleState {
  /** BCP 47 tag, e.g. `en-US` (default), `ja-JP`, `fr-FR`. */
  value: AppLocaleTag;
}

const initialState: LocaleState = { value: DEFAULT_LOCALE as AppLocaleTag };

export const localeSlice = createSlice({
  name: "locale",
  initialState,
  reducers: {
    setLocale: (state, action: PayloadAction<AppLocaleTag>) => {
      state.value = action.payload;
    },
  },
});

export const { setLocale } = localeSlice.actions;
export const localeReducer = localeSlice.reducer;
